namespace advisorop.components.advisor {
    ////'use strict';l
    //export enum AW_Step {
    //    BASIC_INFORMATION = 10,
    //    DEFINE_OUTSIDE_HOLDINGS = 20,
    //    DEFINE_RTG = 30,
    //    INVESTMENT_PROPOSAL = 40,
    //    OPEN_ACCOUNT = 50
    //}

    export class NewNewAccountWizController {

        $router;

        // this one is in use
        isInitializing: boolean = true;
        accountInitialized: boolean = false;
        custodianAccountInitialized: boolean = false;
        custodianAccountWatchesOn: boolean = true;

        lovs: Array<domains.ILOV> = [];
        
        scopeOpenAccountForm: any;

        public step: AW_Step = AW_Step.BASIC_INFORMATION;
        AW_Step = AW_Step;
        InvestmentType = domains.InvestmentType;

        hasRtgHoldings: boolean = false;
        allowOptionalRtgHoldings: boolean = false;
        selectedSkippOption: boolean;
        transmitting: boolean;

        setupCode_AddExisting: number = domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT;
         
        // Funding Schedule
        totalInvestmentAmount: number = 0;
        investmentAmount: number = 0;
        dgFundingComponents: DevExpress.ui.dxDataGridOptions;
        fundingComponents: domains.IAccountFundingComponent[] = [];
        fundingSources: domains.ILOV[];
        selFundingSource: domains.ILOV;

        // subscription doc
        uploadUrl: string = "/api/advisor/uploadaccountdocument/1314/18";
        fuValue: any[] = [];
        fuOptions: DevExpress.ui.dxFileUploaderOptions;

        //custodian and office range variables
        selCustodian: domains.ICustodianAdvisoryFirm;
        selOfficeRange: domains.ICustodianAdvisoryFirmOfficeRange;
        custodians: domains.ICustodianAdvisoryFirm[] = [];
        officeRanges: domains.ICustodianAdvisoryFirmOfficeRange[] = [];

        // custodian account
        createNewCustodianAccount: boolean = false;
        //selCustodianAccount: domains.IAccount;
        //custodianAccounts: domains.IAccount[];
        //custodianAccountsSelections: domains.IAccount[];
        custodianAccountIsDirty: boolean = false;
        beneficiariesAreDirty: boolean = false;
        invamountIsDirty: boolean = false;
        sweepIsOn: boolean = false;
        hideHoldingsGrid: boolean = false;
         
        //supplemental fields
        sourcesOfInitialFunds: domains.ILOV[];
        selSourceOfInitialFunds: domains.ILOV;
        accountPurposes: domains.ILOV[];
        selAccountPurpose: domains.ILOV;
        pricingTypes: domains.ILOV[];
        selPricingType: domains.ILOV;
        brokerageTypes: domains.ILOV[];
        selBrokerageType: domains.ILOV;
        sweepStatuses: domains.ILOV[];
        selSweepStatus: domains.ILOV;
        selCustStateGiftGiven: domains.ILOV;
        selCustMannerOfGift: domains.ILOV;
        custStateGiftGiven: Array<domains.ILOV> = [];
        custMannerOfGifts: Array<domains.ILOV> = [];
        countries: domains.ILOV[];
        selUsOfficialOfficeCountry: domains.ILOV;
        usCountryCode: string = "US";
        selJointTenancyState: domains.ILOV;
        jointTenancyState: Array<domains.ILOV> = [];

        updateFrequencies: Array<domains.ILOV> = [];
        selUpdateFrequency: domains.ILOV;

        //repfee group
        repfeeGroups: domains.IRepFeeGroup[] = [];
        selRepfeeGroup: domains.IRepFeeGroup;
        repGroupFeeOptions: domains.RepGroupFeeOptions = domains.RepGroupFeeOptions.WITH_FEES;

        // RTQ
        rtqs: Array<domains.IRTQ> = [];
        rtq: domains.IRTQ = {};

        dxExecDateValidator: DevExpress.ui.dxValidatorOptions;
        dxCustDateValidator: DevExpress.ui.dxValidatorOptions;

        updatingAccountLadda: boolean = false;
        //loadingCustodianAccountsLadda: boolean = false;
        reservingCustodianAccountLadda: boolean = false;
        savingCustodianAccountLadda: boolean = false;
        unlockingAccountNumberLadda: boolean = false;
        uploadingToCustodianLadda: boolean = false;
        openingAccountLadda: boolean = false;
        loadingDoclistLadda: boolean = false;
        genCustodianDocLadda: boolean = false;
        savingFundingLadda: boolean = false;
        cuAccountController: NewCuAccountController;
        accountInvestmentController: CuAccountinvestmentController;
        cuProposalController: components.common.NewCuProposalController;
        outsideHoldingsController: advisorop.components.servicer.OutsideHoldingsListController
            | advisorop.components.servicer.OutsideHoldingsListNewController;
        orionAccountData: any = null;

        // Which manual-holdings grid this account gets - see the $watch in the constructor.
        securityPlanLoaded: boolean = false;
        securityPlanExists: boolean = false;
        private securityPlanAccountId: number = 0;

        //accountSetupOpen: boolean = false;
        accountOpened: boolean = false;
        user: domains.identity.IUser;
        impersonatedByServicer: boolean = false;

        reportAppWnd: Window;

        custodianDocuments: domains.ICustodianDocument[] = [];
        selCustodianDocuments: domains.ICustodianDocument[] = [];
        selCustodianDocument: domains.ICustodianDocument = {};
        showGenerateDocButton: boolean = false;
        generateDocLabel: string = "Generate Document";
        laserAppGenRequest: domains.ILaserAppGenRequest[] = [];
        laserAppWnd: Window;
        flagDeletedHoldings: number;
        showDocumentSelection: boolean = false;

        nonCustodianOrg: number = domains.DocumentOrganization.NONCUSTODIAN_SUBSCRIPTION;
        custodianOrg: number = domains.DocumentOrganization.CUSTODIAN;


        // New New Wiz additions (GL)
        titleType_529PlanAccount: number = domains.TitleType._529_PLAN_ACCOUNT;
        titleType_IRA: number = domains.TitleType.IRA;
        titleType_IndividualTOD: number = domains.TitleType.INDIVIDUAL_TRANSFER_ON_DEATH;
        titleType_JointTOD: number = domains.TitleType.JOINT_TRANSFER_ON_DEATH;
        accountType_OutsideInvestment: number = domains.InvestmentType.OUTSIDE_INVESTMENT;
        accountType_DirectInvestment: number = domains.InvestmentType.DIRECT_INVESTMENT;
        accountType_IndividualHoldings: number = domains.InvestmentType.INDIVIDUAL_HOLDINGS;
        accountType_ManagedModels: number = domains.InvestmentType.MANAGED_MODELS;
        accountType_SMA: number = domains.InvestmentType.SMA;
        accountType_CustodianAccount: number = domains.InvestmentType.CUSTODIAN_ACCOUNT;
        productType_LifeInsurance: number = domains.ProductType.LIFE_INSURANCE;
        productType_OtherInsurance: number = domains.ProductType.OTHER_INSURANCE;
        firmType_RIA: number = domains.FirmType.REGISTERED_INVESTMENT_ADVISOR;
        step_BASIC_INFORMATION: number = AW_Step.BASIC_INFORMATION;
        step_DEFINE_OUTSIDE_HOLDINGS: number = AW_Step.DEFINE_OUTSIDE_HOLDINGS;
        step_DEFINE_RTG: number = AW_Step.DEFINE_RTG;
        step_INVESTMENT_PROPOSAL: number = AW_Step.INVESTMENT_PROPOSAL;
        step_OPEN_ACCOUNT: number = AW_Step.OPEN_ACCOUNT;
        //basicInformationComplete: boolean = false;
        //rtgInformationComplete: boolean = false;
        manualInformationComplete: boolean = false;
        beneInformationComplete: boolean = false;
        beneficiariesSkipped: boolean = false;
        invamountInformationComplete: boolean = false;
        eSignatureInformationComplete: boolean = false;

        showHelper: boolean = false;
        completeColor: string = "lightgreen";
        incompleteColor: string = "yellow";

        actionStatusColor: string = this.completeColor;
        invamountStatusColor: string = this.incompleteColor;
        beneStatusColor: string = this.incompleteColor;
        rtgStatusColor: string = this.incompleteColor;
        manualStatusColor: string = this.completeColor;
        subscriptionStatusColor: string = this.incompleteColor;
        custodianStatusColor: string = this.incompleteColor;
        custodianStatusDocColor: string = this.incompleteColor;
        subscriptionDocumentStatusColor: string = this.incompleteColor;
        custodianAccountStatusColor: string = this.incompleteColor;
        repFeeGroupStatusColor: string = this.incompleteColor;
        eSignatureStatusColor: string = this.incompleteColor;
        manualSetupDirty: boolean = false;

        showRTGPanel: boolean = true;
        showManualPanel: boolean = true;
        showBenePanel: boolean = true;
        showInvamountPanel: boolean = true;
        showSubscriptionPanel: boolean = true;
        showCustodianPanel: boolean = true;
        showCustodianDocPanel: boolean = true;
        showESignaturePanel: boolean = true;
        showRepfeePanel: boolean = true;

        cuAccountControllerReady: boolean = false;
        cuAccountInvestmentControllerReady: boolean = false;
        cuProposalControllerReady: boolean = false;
        cuOutsideHoldingsControllerReady: boolean = false;

        initTimer: any;

        quickAddOption: boolean = false;

        // Loading panel position is higher on this screen than on others... bceause it seems
        // to paint in odd places when entering for the second+ times if placed lower in the screen.
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#dashHeaderBody" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading...",
            bindingOptions: {
                visible: "vm.isInitializing"
            },
            onShown: function () {
                //setTimeout(function () {
                //    $scope.$apply(function () {
                //        $scope.loadingVisible = false;
                //    });
                //}, 3000);
            },
            onHidden: function () {
                //$scope.employeeInfo = employee;
            }
        };

        //private repGroupApi: services.RepGroupApi,
        static $inject = ["advisorService", "generalService", "identityService", "$scope", "$q", "accountApi", "orionService"];
        constructor(private advisorService: services.AdvisorService,
            private generalService: advisorop.services.GeneralService,
            private identityService: services.IdentityService,
            private $scope: ng.IScope,
            private $q: ng.IQService,
            private accountApi: services.AccountApi,
            private orionService: services.OrionService) {

            // listen for selections changes from multiselectCustodianDocuments
            //this.$rootScope.$on('SelectedDocsChanged', function (event, docs: domains.ICustodianDocument[]) {
            //    this.selCustodianDocuments = [];

            //    var isLaserappPlatform = false;
            //    for (var doc of docs) {
            //        if (doc.platform === domains.ReportingPlatform.LASERAPP) {
            //            isLaserappPlatform = true;
            //            this.selCustodianDocuments.push(angular.copy(doc));
            //        }
            //    }
            //    this.isLaserappPlatform = isLaserappPlatform;
            //});


            // reload custodians when firm change
            this.$scope.$watch("vm.isInitializing", () => {
                //console.log("I AM IN HERE INITIALIZING HAS CHANGED!!!*#*#*#*#*#*#*#*#*#*#*#*#*##*")
            });

            // reload custodians when firm change
            this.$scope.$watch("vm.accountApi.paccount.advisoryFirmId", () => {
                if (this.accountApi.paccount.advisoryFirmId > 0) {
                    //console.log("CAUGHT ADVISORY FIRM CHANGE FROM Cu-Account #$#$#$#$$#$#$#$#$#$#$#$#$#");
                    //if (this.cuAccountController && this.cuAccountController.selAdvisoryFirm && this.cuAccountController.selAdvisoryFirm.id > 0) {
                    //console.log("CAUGHT ADVISORY FIRM CHANGE FROM Cu-Account AAAAAAAAA");
                    this.loadCustodians(this.accountApi.paccount.advisoryFirm.id);
                } //else {
                  //  console.log("CAUGHT ADVISORY FIRM CHANGE FROM Cu-Account BBBBBBBBBB");
                  //  this.custodians = [];
                //}
            });

            // The manual-holdings grid has to match the one on the account's Outside Holdings tab:
            // firms on an AF allocation plan edit the AF buckets, everyone else edits the legacy
            // four columns. Resolve which one applies as soon as the account exists.
            this.$scope.$watch("vm.accountApi.paccount.id", () => {
                const accountId = this.accountApi.paccount ? this.accountApi.paccount.id : 0;
                if (!(accountId > 0) || accountId === this.securityPlanAccountId)
                    return;

                this.securityPlanAccountId = accountId;
                this.securityPlanLoaded = false;
                this.securityPlanExists = false;
                this.accountApi.getActiveSecurityAllocationPlan(accountId)
                    .then((data) => {
                        this.securityPlanExists = !!data.data;
                        this.securityPlanLoaded = true;
                    })
                    .catch((reason) => {
                        // Fall back to the legacy grid rather than showing nothing at all.
                        console.log(reason.status + ' ' + reason.data);
                        this.securityPlanLoaded = true;
                    });
            });

            //this.$scope.$watch("vm.custodianAccountInitialized", () => { 
            //    if (this.custodianAccountInitialized) {
            //        setTimeout(() => {
            //            this.$scope.$watch("vm.accountApi.pcustodianAccount.custDateGiftGiven", () => {
            //                if (this.custodianAccountWatchesOn) {
            //                    if (this.accountApi.paccount.setupCreationType != domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT && this.accountApi.paccount.setupCustodianId)
            //                        console.log("SETTING IT DIRTY 11111111");
            //                        this.custodianAccountIsDirty = true;
            //                }
            //            });
            //            this.$scope.$watch("vm.accountApi.pcustodianAccount.jointAgreementExecDate", () => {
            //                if (this.custodianAccountWatchesOn) {
            //                    if (this.accountApi.paccount.setupCreationType != domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT && this.accountApi.paccount.setupCustodianId)
            //                        console.log("SETTING IT DIRTY 22222222");
            //                        this.custodianAccountIsDirty = true;
            //                }
            //            });
            //        },4000);
            //    }
            //});

            // We can force this value from inside new-cu-account via the account creation shortcut settings
            //$scope.$watch("vm.accountApi.paccount.isNewCustodianAccount", () => {
            //    this.createNewCustodianAccount = (this.accountApi.paccount.isNewCustodianAccount == true);
            //});

            this.dgFundingComponents = {
                export: {
                    enabled: false,
                    //fileName: "InvestmentModels"
                },
                bindingOptions: {
                    dataSource: "vm.fundingComponents"
                    //,"columns[0].lookup.dataSource": "vm.investmentModels"
                },
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                noDataText: "Please add funding sources",
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,

                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                columns: [
                    { dataField: "amount", caption: "Funding Amount", cssClass: "advisorop-gridcol", format: "currency", visible: true, width: 150 },
                    { dataField: "fundingSourceName", caption: "Funding Source", cssClass: "advisorop-gridcol", visible: true, width: 150 },
                    { dataField: "id", caption: "Click to remove row:", cssClass: "advisorop-gridcol", cellTemplate: "btnActions" }
                ]
            };

            this.fuOptions = {
                bindingOptions: {
                    value: "vm.fuValue",
                    uploadUrl: "vm.uploadUrl"
                },
                //uploadUrl: "/api/advisor/uploadaccountdocument/1014/2",
                selectButtonText: "Select document(s) for upload",
                labelText: " or Drop files here...",
                multiple: true,
                uploadMode: "useButtons", //useButtons instantly
                accept: "*", //"image/*",
                readyToUploadMessage: "Document is ready for upload",
                //buttonText: "Upload documents <br/> Blah",
                uploadButtonText: "Upload selected documents",
                showFileList: true
            };

            this.dxExecDateValidator = {
                validationRules: [
                    { type: "required", message: "Joint Trust Agreement Execution Date is required" }
                ]
            };

            this.dxCustDateValidator = {
                validationRules: [
                    { type: "required", message: "Custodian Gift Date is required" }
                ]
            };

            //console.log("AW_Step", this.AW_Step);
        }

        setUpDateWatches(): void {
            //setTimeout(() => {
                this.$scope.$watch("vm.accountApi.pcustodianAccount.custDateGiftGiven", () => {
                    if (this.custodianAccountWatchesOn
                        && this.requireCustodialInfo()
                        && this.accountApi.paccount.setupCreationType != domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT
                        && this.accountApi.paccount.setupCustodianId) {
                        //console.log("SETTING IT DIRTY 11111111");
                        /***Account opening simplification effort***/
                        //this.custodianAccountIsDirty = true;
                    }
                });
                this.$scope.$watch("vm.accountApi.pcustodianAccount.jointAgreementExecDate", () => {
                    if (this.custodianAccountWatchesOn
                        && this.requireJointInfo
                        && this.accountApi.paccount.setupCreationType != domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT
                        && this.accountApi.paccount.setupCustodianId) {
                        //console.log("SETTING IT DIRTY 22222222");
                        /***Account opening simplification effort***/
                        //this.custodianAccountIsDirty = true;
                    }
                });
            //}, 4000);
        }

        expandAll(): void {
            this.showInvamountPanel = true;
            this.showManualPanel = true;
            this.showSubscriptionPanel = true;
            this.showCustodianPanel = true;
            this.showCustodianDocPanel = true;
            this.showRepfeePanel = true;
            this.showRTGPanel = true;
            this.showESignaturePanel = true;
            if (this.cuAccountController) {
                this.cuAccountController.expandAll();
            }
            if (this.accountInvestmentController) {
                this.accountInvestmentController.expandAll();
            }
            if (this.cuProposalController) {
                this.cuProposalController.expandAll();
            }
        }

        collapseCompleted(localOnly: boolean = false): void {
            if (this.invamountInformationComplete) {
                this.showInvamountPanel = false;
            }
            if (this.manualInformationComplete) {
                this.showManualPanel = false;
            }
            if (this.beneInformationComplete) {
                this.showBenePanel = false;
            }
            //if (this.isRTGCompleted())
            if (this.accountApi.rtgInformationComplete) {
                this.showRTGPanel = false;
            }
            if (this.eSignatureInformationComplete) {
                this.showESignaturePanel = false;
            }
            if (!localOnly) {
                if (this.cuAccountController) {
                    this.cuAccountController.collapseCompleted();
                }
                if (this.accountInvestmentController) {
                    this.accountInvestmentController.collapseCompleted();
                }
                if (this.cuProposalController) {
                    this.cuProposalController.collapseCompleted();
                }
            }
        }

        collapseAll(): void {
            this.showInvamountPanel = false;
            this.showManualPanel = false;
            this.showSubscriptionPanel = false;
            this.showCustodianPanel = false;
            this.showCustodianDocPanel = false;
            this.showRepfeePanel = false;
            this.showBenePanel = false;
            this.showRTGPanel = false;
            this.showESignaturePanel = false;
            if (this.cuAccountController) {
                this.cuAccountController.collapseAll();
            }
            if (this.accountInvestmentController) {
                this.accountInvestmentController.collapseAll();
            }
            if (this.cuProposalController) {
                this.cuProposalController.collapseAll();
            }
        }

        toggleManualPanel(): void {
            this.showManualPanel = !this.showManualPanel;
        }
        toggleBenePanel(): void {
            this.showBenePanel = !this.showBenePanel;
        }
        toggleInvamountPanel(): void {
            this.showInvamountPanel = !this.showInvamountPanel;
        }
        toggleSubscriptionPanel(): void {
            this.showSubscriptionPanel = !this.showSubscriptionPanel;
        }
        toggleCustodianPanel(): void {
            this.showCustodianPanel = !this.showCustodianPanel;
        }
        toggleCustodianDocPanel(): void {
            this.showCustodianDocPanel = !this.showCustodianDocPanel;
        }
        toggleRepfeePanel(): void {
            this.showRepfeePanel = !this.showRepfeePanel;
        }
        toggleRTGPanel(): void {
            this.showRTGPanel = !this.showRTGPanel;
        }
        toggleESignaturePanel(): void {
            this.showESignaturePanel = !this.showESignaturePanel;
        }

        getProposalStepTitle(): string {
            if (!this.accountOpened) {
                return (this.cuAccountController
                    && ((this.cuAccountController.hasTamp()
                        && this.cuAccountController.selTamp
                        && (this.cuAccountController.selTamp.type == domains.TampType.EXTERNAL_TAMP)) || this.cuAccountController.hasSubscriptionAgreement()
                    )) ? "Investment setup" : "Investment proposal";
            }
            else {
                return "Account Setup";
            }
        }

        unlockAccountNumber = (): ng.IPromise<string> => {
            this.unlockingAccountNumberLadda = true;
            return this.advisorService.unlockAccountNumber(this.accountApi.pcustodianAccount.id)
                .then(data => {
                    toastr.success("Account number has been unlocked");
                    const tmpAccount = <domains.IAccount>data.data;
                    this.accountApi.pcustodianAccount.isNumberReserved = tmpAccount.isNumberReserved;
                    return data.data;
                }, err => this.generalService.showError(err)).finally(() => {
                    this.unlockingAccountNumberLadda = false;
                });
        };

        resetCustodianAccountData() {

            //console.log("RESETTING CUSTODIAN ACCOUNT DATA");

            // Reset fields on accounts relating to custodian account linkage
            if (this.accountApi.paccount.custodianAccountId) {
                this.accountApi.paccount.number = "";
            }
            this.accountApi.paccount.custodianAccountId = null;
            this.accountApi.paccount.isNewCustodianAccount = false;

            // User will need to reload custodian accounts if they want to link to an existing one
            //this.custodianAccounts = null;
            //this.custodianAccountsSelections = null;

            // Reset custodian account-related form fields
            this.createNewCustodianAccount = false;
            this.accountApi.pcustodianAccount.name = null;
            this.selCustodian = null;
            this.officeRanges = null;
            this.selCustStateGiftGiven = null;
            this.selCustMannerOfGift = null;
            this.selSourceOfInitialFunds = null;
            this.selAccountPurpose = null;
            this.selPricingType = null;
            this.selBrokerageType = null;
            this.selSweepStatus = null;
            this.selJointTenancyState = null;
            this.accountApi.pcustodianAccount.jointAgreementExecDate = null;
            this.accountApi.pcustodianAccount.custStateGiftGiven = null;
            this.accountApi.pcustodianAccount.custDateGiftGiven = null;
            this.accountApi.pcustodianAccount.custMannerOfGift = null;
            this.accountApi.pcustodianAccount.custAgeTermination = null;
            this.accountApi.pcustodianAccount.confirmSuppression = null;
            this.accountApi.pcustodianAccount.sweepFundsPercent = 0;
            this.accountApi.pcustodianAccount.sweepId = null;
            this.accountApi.pcustodianAccount.foreignBankAccount = null;
            this.accountApi.pcustodianAccount.centralBankAcctInd = null;
            this.accountApi.pcustodianAccount.foreignFinInstInd = null;
            this.accountApi.pcustodianAccount.marginDebtIndicator = null;
            this.accountApi.pcustodianAccount.nonUSOfficial = null;
            this.accountApi.pcustodianAccount.usOfficialFirstName = null;
            this.accountApi.pcustodianAccount.usOfficialLastName = null;
            this.accountApi.pcustodianAccount.usOfficialOfficeHeld = null;
            this.accountApi.pcustodianAccount.usOfficialOfficeCountry = null;
            this.accountApi.pcustodianAccount.redemptionPriority = null;
            this.accountApi.pcustodianAccount.privateBankAccount = null;
            this.accountApi.pcustodianAccount.isDocumentationSent = null;
            this.accountApi.pcustodianAccount.isNumberReserved = null;
            this.accountApi.pcustodianAccount.initialFundsOtherText = null;
            this.accountApi.pcustodianAccount.accountPurposeOtherText = null;
            this.accountApi.pcustodianAccount.jointTenancyState = null;
            this.accountApi.pcustodianAccount.jointHoldersMarried = null;
            this.accountApi.pcustodianAccount.extApiTransmitted = null;
            this.accountApi.pcustodianAccount.extApiTransmittedStr = null;
        }

        updateAccount(): ng.IPromise<boolean> {

            this.updatingAccountLadda = true;

            this.cuAccountController.bindAccountFromForm();

            if (this.selCustodian)
                this.accountApi.paccount.custodianId = this.selCustodian.custodianId;
            else
                this.accountApi.paccount.custodianId = null;

            if (this.selPricingType)
                this.accountApi.paccount.pricingType = this.selPricingType.value;
            else
                this.accountApi.paccount.pricingType = null;

            if (this.createNewCustodianAccount)
                this.accountApi.paccount.isNewCustodianAccount = true;
            else
                this.accountApi.paccount.isNewCustodianAccount = false;

            // If this account is linked to a custodian account, and we are not creating the custodian account at this time,
            // then we need to un-link the account, because the user has changed the investors on this account.
            // Investors need to be the same between the account and custodian account that it is linked to.
            // This unlinks the accounts and resets various form fields.
            if (this.cuAccountController.investorsDirty == true && this.createNewCustodianAccount == false) {
                this.resetCustodianAccountData();
                this.cuAccountController.investorsDirty = false;
            }

            return this.advisorService.updateAccount(this.accountApi.paccount)
                .then(response => {
                    toastr.success("Account has been successfully updated.");
                    this.accountApi.paccount = response.data;
                    //this.accountId = this.accountApi.paccount.id;
                    return true;
                }, err => this.generalService.showError(err)).finally(() => this.updatingAccountLadda = false);
        };

        finalSetupAndChecks(): boolean {

            // Custodan account final setup and checks
            //if (!this.createNewCustodianAccount) {
            //    this.accountApi.paccount.isNewCustodianAccount = false;
            //    if (this.accountApi.pcustodianAccount.id > 0) {
            //    //if (this.selCustodianAccount) {
            //        this.accountApi.paccount.custodianAccountId = this.accountApi.pcustodianAccount.id;
            //        this.accountApi.paccount.number = this.selCustodian.custodian.name + "-" + this.accountApi.pcustodianAccount.number;
            //    }
            //} else {
            //    this.accountApi.paccount.custodianAccountId = this.accountApi.pcustodianAccount.id;
            //    this.accountApi.paccount.number = this.accountApi.pcustodianAccount.custodianName + "-" + this.accountApi.pcustodianAccount.number;
            //}
            if (!this.createNewCustodianAccount) {
                this.accountApi.paccount.isNewCustodianAccount = false;
            }
            if (this.accountApi.pcustodianAccount.id > 0) {
                this.accountApi.paccount.custodianAccountId = this.accountApi.pcustodianAccount.id;
                // moved this logic to server inside activateAccount/openAccount
                //this.accountApi.paccount.number = this.accountApi.pcustodianAccount.custodianName + "-" + this.accountApi.pcustodianAccount.number;
            }

            // RTG final check
            if (this.accountApi.paccount.advisoryFirm.firmType == domains.FirmType.REGISTERED_INVESTMENT_ADVISOR) {
                // outside accounts can be without RTG
                if (this.hasRTGStep()) {
                    let checking = this.checkAreRtgsAssignedToInvestors();
                    if (!checking) {
                        toastr.warning("Please assign RTG for each investor in the account.");
                        return false;
                    }
                }
            }
            else if (this.accountApi.paccount.advisoryFirm.firmType == domains.FirmType.BROKER_DEALER) {
                // RTG must be defined on Account Title level
            }
            else {
                // We don't support other options right now
            }

            return true;
        }

        activateAccount(): ng.IPromise<boolean> {
            return this.advisorService.activateAccount(this.accountApi.paccount)
                .then((data) => {
                    toastr.success("You have successfully opened the account.");
                    return true;
                }, err => this.generalService.showError(err));
        }

        beneficiariesChanged() {
            //console.log("beneficiariesListChanged");
            this.beneficiariesAreDirty = true;
            this.beneInformationComplete = false;
            this.beneficiariesSkipped = false;
            if (this.accountApi.paccount.accountType != this.accountType_OutsideInvestment && this.accountApi.paccount.setupCreationType != domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT) {
                console.log("SETTING custodianAccountIsDirty DIRTY 33333333");
                this.custodianAccountIsDirty = true;
            }
            this.beneStatusColor = this.incompleteColor;
        }

        beneficiariesComplete() {
            //console.log("beneficiariesListSaved");
            this.beneficiariesAreDirty = false;
            this.beneficiariesSkipped = false;
            this.beneInformationComplete = true;
            this.beneStatusColor = this.completeColor;
            //this.toggleBenePanel();
            this.showBenePanel = false;
        }

        skipBeneficiaries(): void {
            this.beneficiariesSkipped = true;
            this.beneInformationComplete = true;
            this.beneficiariesAreDirty = false;
            this.beneStatusColor = this.completeColor;
            this.showBenePanel = false;
        }

        checkFundingComponentsComplete(): void {
            if (this.fundingComponents.length > 0) {
                this.invamountInformationComplete = true;
                this.invamountStatusColor = this.completeColor;
            } else {
                this.invamountInformationComplete = false;
                this.invamountStatusColor = this.incompleteColor;
            }
        }

        addFundingComponent(): void {
            // default to 'TBD' funding source if available
            this.fundingSources.findIndex(fs => {
                if (fs.name == 'TBD') {
                    this.selFundingSource =fs;
                    return true;
                }
            });

            if (this.investmentAmount <= 0) {
                toastr.error("Investment amount must be greater than zero");
                return;
            } else if (!this.selFundingSource) {
                toastr.error("Please select a funding source");
                return;
            }
            // Only one funding component allowed, replace if exists or add new
            const fundingComponent: domains.IAccountFundingComponent = {
                id: 0,
                accountId: this.accountApi.paccount.id,
                amount: +this.investmentAmount,
                fundingSource: this.selFundingSource.value,
                fundingSourceName: this.selFundingSource.name
            };

            if (this.fundingComponents.length >= 1) {
                this.fundingComponents[0] = fundingComponent;
            } else {
                this.fundingComponents.push(fundingComponent);
            }

            this.calcBindTotalInvestmentAmount(true);

            this.accountApi.investmentSetupDirty = true;
            this.invamountIsDirty = true;
        };

        removeFundingComponent(fc: domains.IAccountFundingComponent): void {
            var ind = this.fundingComponents.indexOf(fc);
            if (ind >= 0) {
                this.fundingComponents.splice(ind, 1);
            }

            this.calcBindTotalInvestmentAmount(true);

            this.accountApi.investmentSetupDirty = true;
            this.invamountIsDirty = true;
        };

        //onChangeAccountOpenStatus(): void {
        //    this.accountApi.investmentSetupDirty = true;
        //    this.invamountIsDirty = true;
        //    this.checkFundingComponentsComplete();
        //}

        rtgChanged(): void {
            //console.log("In RTGChanged callback");
            if (this.checkAreRtgsAssignedToInvestors() == true) {
                this.rtgStatusColor = this.completeColor;
                this.accountApi.rtgInformationComplete = true;
                this.showRTGPanel = false;
                //console.log("RTG is complete");
            } else {
                this.rtgStatusColor = this.incompleteColor;
                this.accountApi.rtgInformationComplete = false;
                this.showRTGPanel = true;
                //console.log("RTG is NOT complete");
            }
        }

        checkAreRtgsAssignedToInvestors(): boolean {
            var forCheck: boolean = true;
            if (this.accountApi.paccount.rtgs) {
                this.accountApi.paccount.rtgs.forEach((item, index) => {
                    if (!item.accountGroup || item.accountGroup == null || !item.accountGroupId || item.accountGroupId == 0) {
                        forCheck = false;
                    }
                })
                if (!forCheck) {
                    return false;
                }
                else {
                    return true;
                }
            } else {
                return false;
            }
        }

        checkManualHoldingsComplete(): void {
            // This is invoked when they press the save button in the manual holdings widget
            if (this.accountApi.paccount.holdingsMaintaindExSystem == true
                || (this.outsideHoldingsController && this.outsideHoldingsController.holdings && this.outsideHoldingsController.holdings.length > 0)) {
                this.manualInformationComplete = true;
                this.manualStatusColor = this.completeColor;
            } else {
                this.manualInformationComplete = false;
                this.manualStatusColor = this.incompleteColor;
            }
        }

        bindCuAccount(ctrl: NewCuAccountController) {
            this.cuAccountController = ctrl;
            //console.log("I AM READY WAS CALLED - cu-account");
            //if (this.cuAccountController.selAdvisoryFirm && (this.cuAccountController.selAdvisoryFirm.id > 0)) {
            //    this.loadCustodians(this.cuAccountController.selAdvisoryFirm.id).then(() => {
            //        this.cuAccountControllerReady = true;
            //    });
            //} else {
            //    //console.log("EMPTYING CUSTODIANS LIST!!! _$_$_$_$_$_$_$_$_$_$_$_$_$_$_$_$_$_$_$_$_");
            //    //this.custodians = [];
            //    this.cuAccountControllerReady = true;
            //}

            this.cuAccountControllerReady = true;
        }

        bindCuAccountinvestment(ctrl: CuAccountinvestmentController) {
            this.accountInvestmentController = ctrl;
            //console.log("I AM READY WAS CALLED - cu-accountinvestment");
            this.cuAccountInvestmentControllerReady = true;
        }

        bindCuOutsideHoldings(ctrl: advisorop.components.servicer.OutsideHoldingsListController
            | advisorop.components.servicer.OutsideHoldingsListNewController) {
            this.outsideHoldingsController = ctrl;
            //console.log("I AM READY WAS CALLED - outside-holdings-list");
            this.cuOutsideHoldingsControllerReady = true;
        }

        syncPricingTypeToCustodianAcct(): void {
            // Copy the pricing type on the proposal to the selected custodian account pricing type
            if (this.accountApi.paccount.proposal != null && this.accountApi.paccount.proposal.custodianPricingType >= 0) {
                if (this.selPricingType == null || this.selPricingType.value != this.accountApi.paccount.proposal.custodianPricingType) {
                    this.selPricingType = <domains.ILOV>{ value: this.accountApi.paccount.proposal.custodianPricingType };
                    if (this.accountApi.paccount.setupCreationType != domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT) {
                        console.log("SETTING custodianAccountIsDirty DIRTY 444444444");
                        /***Account opening simplification effort***/
                        this.custodianAccountIsDirty = true;
                    }
                }
            }
        }
   
        bindCuProposal(ctrl: components.common.NewCuProposalController): void {
            this.cuProposalController = ctrl;
            this.syncPricingTypeToCustodianAcct();
            this.cuProposalControllerReady = true;
        };

        onOrionAccountSelected(orionAccount: any): void {
            //console.log(`onOrionAccountSelected officeRanges${this.officeRanges.length}, orionAccount: ${JSON.stringify(orionAccount)}`);
            this.orionAccountData = orionAccount;
            // Try to auto-select office range if office ranges are already populated
            if (orionAccount && this.officeRanges && this.officeRanges.length > 0) {
                this.trySelectOfficeRangeFromOrion();
            }
        }

        trySelectOfficeRangeFromOrion(): void {
            // Auto-select office range based on RR field if account not yet created
            //console.log(`Trying to auto-select office range ${this.orionAccountData.rr} from Orion account data: ${JSON.stringify(this.officeRanges)}`);
            if (this.orionAccountData && this.orionAccountData.rr && 
            // (!this.accountApi.paccount.id || this.accountApi.paccount.id <= 0) &&
                (this.selOfficeRange === null || this.selOfficeRange === undefined ) &&
                this.officeRanges && this.officeRanges.length > 0) {
                // console.log(`Matching Orion RR: ${this.orionAccountData.rr}`);
                const rrToMatch = this.orionAccountData.rr.toString().trim();
                this.selOfficeRange = this.officeRanges.filter(v => { 
                    return v.code && v.code.toString().trim() === rrToMatch; 
                })[0];
                
                if (this.selOfficeRange) {
                    console.log(`Auto-selected office range ${this.selOfficeRange.code} based on Orion RR data`);
                    this.setCustodianAcctIsDirty();
                } else {
                    console.log(`No matching office range found for Orion RR: ${this.orionAccountData.rr}`);
                }
            }
        }

        toggleHelper() {
            this.showHelper = false; this.showHelper = true;
        }

        bindSetupCustodianId(): void {
            // console.log("IN BIND SETUP CUSTODIAN 111111111 $_#_$_#$_#_$#$_#_$_#$_#$_#$_#_$#");
            if (this.accountApi.paccount.setupCustodianId) {
                //console.log("IN BIND SETUP CUSTODIAN 222222222 $_#_$_#$_#_$#$_#_$_#$_#$_#$_#_$#");
                this.createNewCustodianAccount = true;
                this.accountApi.paccount.isNewCustodianAccount == true;
                this.selCustodian = this.custodians.filter((v) => { return v.custodianId == this.accountApi.paccount.setupCustodianId; })[0];
                if (this.selCustodian && this.selCustodian.custodian.hasOfficeRanges)
                    this.officeRanges = this.selCustodian.officeRanges;
                else
                    this.officeRanges = [];
                
                // Try to auto-select office range from Orion account data after office ranges are populated
                this.trySelectOfficeRangeFromOrion();
                
                this.setCustodianAcctIsDirty();
            }
        }

        cuAccountDataChanged(element: string) {
            //console.log("Inside cuAccountDataChanged based on", element);
            // If we are on a future step and the user changes something that invalidates the first step
            // then we are back at the first step. This will cause future steps to be hidden until we
            // pass this first step again.
            if (this.cuAccountController && this.cuAccountController.basicInformationComplete == false) {
                //console.log("setting step to basic information step.");
                this.step = AW_Step.BASIC_INFORMATION;
            }

            // If this account is linked to a custodian account, and we are NOT creating the custodian account at this time,
            // then we need to un - link the account, because the user has changed the investors on this account.
            // Investors need to be the same between the account and custodian account that it is linked to.
            // This unlinks the accounts and resets various form fields.
            if (this.cuAccountController &&
                this.cuAccountController.investorsDirty == true && this.createNewCustodianAccount == false && this.accountApi.paccount.custodianAccountId != null) {
                this.resetCustodianAccountData();
                this.cuAccountController.investorsDirty = false;
            }

            // When the account creation shortcut changes, if the shortcut type changes to direct then we need to un-link any
            // custodian account that is linked to this account.
            // On the contrary, if the user switches to a Custodian shortcut type, then we need to prepare for creation of a new custodian account.
            if (element == "acShortcut") {
                //console.log("IN HERE ^^^^^^^^^^^^^this.accountApi.paccount.setupDirectAccountFlag is", this.accountApi.paccount.setupDirectAccountFlag);
                // GL NEED TO STILL FIX THIS!!!!
                //if (this.accountApi.paccount.setupDirectAccountFlag == true) {
                //    this.resetCustodianAccountData();
                //} else {
                    this.bindSetupCustodianId();
                //}
            }
        }

        BindCustodianFromAccount(): void {
            this.selCustodian = null;
            this.officeRanges = null;
            //console.log("TRYING TO BIND CUSTODIAN FROM ACCOUNT")
            if (this.custodians && (this.custodians.length > 0)) {
                var cid = 0;
                if (this.accountApi.pcustodianAccount.custodianId > 0) {
                    cid = this.accountApi.pcustodianAccount.custodianId;
                } else if (this.accountApi.pcustodianAccount.setupCustodianId > 0) {
                    cid = this.accountApi.pcustodianAccount.setupCustodianId;
                }
                if (cid > 0) {
                    var cust = this.custodians.filter((v) => { return v.custodianId == this.accountApi.pcustodianAccount.custodianId; });
                    if (cust.length <= 0)
                        return;
                } else {
                    return;
                }
                this.selCustodian = cust[0];
                if (this.selCustodian.custodian.hasOfficeRanges) {
                    this.officeRanges = this.selCustodian.officeRanges;
                    if (this.accountApi.pcustodianAccount && this.accountApi.pcustodianAccount.officeRangeId <= 0)
                        return;
                    var sor = this.officeRanges.filter((v) => { return v.id == this.accountApi.pcustodianAccount.officeRangeId; });
                    if (sor.length > 0) {
                        // console.log("BINDING OFFICE RANGE FROM CUSTODIAN ACCOUNT DATA", sor[0]);
                        this.selOfficeRange = sor[0];
                    }
                }
            }
        }

        okToOpenAccount(): boolean {
            var ret: boolean = false;

            // outside investments can be open as soon as basic setup is complete
            //if (this.accountApi.paccount && this.accountApi.paccount.accountType == this.accountType_OutsideInvestment
            //    && this.accountApi.basicSetupDirty == false)
            //    return true;

            // we can not be initializing this module
            if (this.isInitializing
                // we can not be an advisor
                || (this.impersonatedByServicer == false)
                // basic information must be complete
                || (this.cuAccountController && this.cuAccountController.basicInformationComplete == false)
                // setup inside this controller can not be dirty
                || this.beneficiariesAreDirty || this.custodianAccountIsDirty || this.invamountIsDirty || this.manualSetupDirty) {

                //console.log("isInitializing", this.isInitializing);
                //console.log("impersonatedByServicer", this.impersonatedByServicer);
                //console.log("basicInformationComplete", (this.cuAccountController && this.cuAccountController.basicInformationComplete == false));
                //console.log("beneficiariesAreDirty", this.beneficiariesAreDirty);
                //console.log("custodianAccountIsDirty", this.custodianAccountIsDirty);
                //console.log("invamountIsDirty", this.invamountIsDirty);
                //console.log("manualSetupDirty", this.manualSetupDirty);
                //console.log("investmentSetupDirty", this.accountApi.investmentSetupDirty);
                //console.log("feeSetupDirty", this.accountApi.feeSetupDirty);
                //console.log("signingSetupDirty", this.accountApi.signingSetupDirty);

                return false;
            }

            // check for RTG, manual account, beneficiary and investment amount complete
            if (((this.accountApi.paccount.accountType != this.accountType_OutsideInvestment || this.hasRtgHoldings) && !this.accountApi.rtgInformationComplete)
                // Change 5/5/20 gl, do not require manual holdings to be complete prior to opening manual account
                // (some manual accounts are insurance accounts and they will never have holdings)
                //|| (this.accountApi.paccount.accountType == this.accountType_OutsideInvestment && !this.manualInformationComplete)
                || (this.BeneficiariesRequired() && !this.beneInformationComplete)
                || (this.accountApi.paccount.accountType != this.accountType_OutsideInvestment && !this.invamountInformationComplete)) {

                // console.log("invamountInformationComplete", this.invamountInformationComplete);
                return false;
            }

            // setup outside this controller can not be dirty
            if (this.accountApi.basicSetupDirty
                || this.accountApi.investmentSetupDirty
                || this.accountApi.feeSetupDirty
                || this.accountApi.signingSetupDirty) {
                console.log("basicSetupDirty", this.accountApi.basicSetupDirty);
                console.log("investmentSetupDirty", this.accountApi.investmentSetupDirty);
                console.log("feeSetupDirty", this.accountApi.feeSetupDirty);
                console.log("signingSetupDirty", this.accountApi.signingSetupDirty);
                return false;
            }

            // If we are using accountInvestmentController and the investment informaton is incomplete, we can not open the account
            // We are not checking for fee information to be complete here because we will allow fee of 0.
            if ((this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT || this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                && this.accountInvestmentController
                && !this.accountInvestmentController.investmentInformationComplete) {
                //console.log("DDDDDDDDDDD", this.accountInvestmentController.investmentInformationComplete);
                return false;
            }

            // If we are using cuProposalController and the investment or fee or signing or billing informaton is incomplete, or we have not created a custodian account, then we can not open the account
            if ((this.accountApi.paccount.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS || this.accountApi.paccount.accountType == domains.InvestmentType.MANAGED_MODELS || this.accountApi.paccount.accountType == domains.InvestmentType.SMA)
                && this.cuProposalController
                && (!this.cuProposalController.investmentInformationComplete || !this.cuProposalController.feeInformationComplete || !this.cuProposalController.signingInformationComplete || !this.cuProposalController.billingInformationComplete)) {
                //console.log("EEEEEEEEEEE");
                return false;
            }

            // If we are creating a new custodian account and we do not yet have a custodian account set up we can not open the account.
            if (this.accountApi.paccount && this.accountApi.paccount.isNewCustodianAccount
                && (!this.accountApi.pcustodianAccount || this.accountApi.pcustodianAccount.id == 0)) {
                //console.log("FFFFFFFFFFF");
                return false;
            }

            return true;
        }

        openAccountStep(): void {
            this.openingAccountLadda = true;
            //if (this.validateOpenAccountForm()) {
            var check1 = this.enableOpenAccountStep();
            if (!check1) {
                toastr.warning("Either proposal needs to be signed or you need to indicate that Discretion Documentation is on File.");
            }
            var check2 = this.finalSetupAndChecks();

            if (check1 == false || check2 == false) {
                this.openingAccountLadda = false;
                return;
            } else {
                this.activateAccount().then(success => {
                    if (success)
                        this.$router.navigate(['AdvisorAccounts', { accountStatus: 0 }]);
                }, err => this.generalService.showError(err)).finally(() => {
                    this.openingAccountLadda = false;
                });
            }
        }

        setExternalHoldings(): ng.IPromise<boolean> {

            //console.log("Account before post.", this.accountApi.paccount);

            return this.advisorService.setExternalHoldingsUpdate(this.accountApi.paccount)
                .then(response => {
                    // not updating the whole account here because we would lose objects such as rtgs, etc.
                    //this.accountApi.paccount = response.data;
                    return true;
                }, err => this.generalService.showError(err));
        };

        deleteHoldingsForAccount(): ng.IPromise<boolean> {
            return this.advisorService.deleteHoldingsAccount(this.accountApi.paccount)
                .then(response => {
                    // not updating the account here because we would lose objects such as rtgs, etc.
                    //this.accountApi.paccount = response.data;
                    //toastr.success("Holdings successfully removed from account.")
                    return true;
                }, err => this.generalService.showError(err));
        };

        saveFundingComponents(): ng.IPromise<boolean> {
            this.savingFundingLadda = true;
            return this.advisorService.saveFundingComponents(this.accountApi.paccount.id, this.fundingComponents)
                .then(response => {
                    // bind the funding components
                    var fundingComponents: domains.IAccountFundingComponent[] = response.data;
                    angular.copy(response.data, this.fundingComponents);
                    angular.copy(response.data, this.accountApi.paccount.fundingComponents);
                    this.calcBindTotalInvestmentAmount(false)
                    if (this.invamountInformationComplete == true)
                        this.showInvamountPanel = false;
                    this.invamountIsDirty = false;
                    return true;
                }, err => this.generalService.showError(err)).finally(() => {
                    this.savingFundingLadda = false;
                });
        };

        getSubscriptionAgreement(): void {
            this.advisorService.getSubscriptionAgreement(this.accountApi.paccount.id, true)
                .then(response => {
                    //console.log("Subscription report URL:", response);
                    this.reportAppWnd = window.open(response.data, "_blank");
                }, err => this.generalService.showError(err));
        }

        // ///////////////////
        // handling events
        //rtqSelected(rtq: domains.IRTQ): void {
        //    this.rtq = rtq;
        //};

        //rtqCreated(rtq: domains.IRTQ): void {
        //    toastr.info("RTQ has been saved successfully.");
        //};

        navigateToDashboard(): void {
            // Navigate advisor back to dashboard
            this.$router.navigate(['Dashboard']);
        }

        proposalCreated(proposal: domains.IProposal): void {
            if (this.impersonatedByServicer == false) {
                this.navigateToDashboard();
                //this.accountApi.paccount.proposal = proposal;
                //this.accountApi.paccount.isDiscretionDocumentationOnFile = proposal.isDiscretionDocumentationOnFile;
            }
            else
                this.syncPricingTypeToCustodianAcct();
        };

        accountStatusChanged(status: boolean): void {
            console.log('accountStatusChanged accountOpened=', status)
            this.accountOpened = status;
        };

        proposalSigned(proposal: domains.IProposal): void {
            //toastr.info("Proposal has been signed. Now you can activate the account.");
            //this.accountApi.paccount.proposal = proposal; //signed
            //this.accountApi.paccount.proposal.signedReportFileName = proposal.signedReportFileName;
            //this.doStep(true);
        };

        onHoldingsRtgChanged(hasRtgHoldings: any) {
            //console.log("Has holdings:", hasRtgHoldings);
            this.hasRtgHoldings = hasRtgHoldings;
            this.checkManualHoldingsComplete();
            this.manualSetupDirty = false;

            // initialize this variable based on existence of RTG assignment. This is currently only used for accounts with manual holdings.
            if (this.accountApi.paccount && this.accountApi.paccount.holdingsMaintaindExSystem) {
                this.allowOptionalRtgHoldings = this.isRTGCompleted();
            }
        }

        setCustodianAcctIsDirty(): void {
            if (this.selSweepStatus) {
                if (this.selSweepStatus.value == domains.SweepStatus.NO_SWEEP) {
                    this.sweepIsOn = false;
                    this.accountApi.pcustodianAccount.sweepId = null;
                    this.accountApi.pcustodianAccount.redemptionPriority = false;
                    this.accountApi.pcustodianAccount.sweepFundsPercent = 0;
                } else {
                    this.sweepIsOn = true;
                }
            }
            if (this.accountApi.paccount.setupCreationType != domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT) {
                console.log("SETTING custodianAccountIsDirty DIRTY 55555555");
                this.custodianAccountIsDirty = true;
            }
        }

        setQuickAddOption(): void {
        }


        //custodianChanged(): void {
        //    this.setCustodianAcctIsDirty();
        //    if (this.selCustodian && this.selCustodian.custodian.hasOfficeRanges)
        //        this.officeRanges = this.selCustodian.officeRanges;
        //    else
        //        this.officeRanges = [];
        //}

        // ng-init in form tag for locating child form element. crazzy
        setOpenFormScope(frm): void {
            this.scopeOpenAccountForm = frm;
        }

        validateOpenAccountForm(): boolean {
            //var formIsValid: boolean = true;
            //console.log("Open account form: ", this.scopeOpenAccountForm);
            if (this.scopeOpenAccountForm) {
                //let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["formFinishNewOpnAccount"]);
                let formIsValid = this.generalService.validateForm(<ng.IFormController>this.scopeOpenAccountForm["formFinishNewOpnAccount"]);
                if (!formIsValid)
                    toastr.error("Custodian account form is not complete. Please complete required fields");
                return formIsValid;
            }
            
            return false;
        }

        //validateSpecificFormFields(items: string[]): boolean {
        //    if (this.scopeOpenAccountForm) {
        //        let formIsValid = this.generalService.validateSpecific(<ng.IFormController>this.scopeOpenAccountForm["formFinishNewOpnAccount"], items);
        //        if (!formIsValid)
        //            toastr.error("Custodian account form is not complete. Please complete required fields");
        //        return formIsValid;
        //    }
        //    return false;
        //}

        //validateSpecificFormField(item: string): boolean {

        //    if (this.scopeOpenAccountForm) {
        //        //let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["formFinishNewOpnAccount"]);
        //        let formIsValid = this.generalService.validateFormSpecificItem(<ng.IFormController>this.scopeOpenAccountForm["formFinishNewOpnAccount"], item);
        //        if (!formIsValid)
        //            toastr.error("Custodian account form is not complete. Please complete required fields");
        //        return formIsValid;
        //    }

        //    return false;
        //}

        // //////////////////
        // loading methods
        loadCustodians(advisoryFirmId: number): ng.IPromise<void> {
            //console.log("LOADING CUSTODIANS FOR FIRM", advisoryFirmId);
            var that = this;
            return this.advisorService.getCustodiansForAdvisoryFirm(advisoryFirmId)
                .then(data => {
                    that.custodians = data.data;
                    //console.log("CUSTODIANS LOADED", that.custodians);
                    this.BindCustodianFromAccount();
                }, err => this.generalService.showError(err));
        }

        //loadRepfeeGroups(): void {
        //    this.advisorService.getRepFeeGroups(domains.RepGroupFeeOptions.WITH_FEES)
        //        .then(data => this.repfeeGroups = data.data, err => this.generalService.showError(err));
        //};

        loadRTQs(titleId: number): void {
            this.advisorService.getRTQs(titleId)
                .success((data) => {
                    this.rtqs = data;
                })
                .error((status, data) => {
                    toastr.error("Error " + status + " " + data);
                });
        }

        //loadCustodianAccounts(accountId: number): ng.IPromise<any> {

        //    if (!accountId)
        //        return this.$q((resolve, reject) => 0);

        //    console.log(`Loading CA accounts that could be selected for account ${accountId}`);

        //    this.loadingCustodianAccountsLadda = true;

        //    return this.accountApi.getCustodianAccounts(accountId, true)
        //        .then(response => {
        //            this.custodianAccounts = response.data;
        //            // Only allow custodian selection dropdown to contain accounts that are open
        //            this.custodianAccountsSelections = this.custodianAccounts.filter((v) => { return v.status == domains.AccountStatus.OPEN });
        //            console.log(`CA accounts has been loaded`, this.custodianAccounts);
        //            return 1;
        //        }, err => this.generalService.showError(err)).finally(() => {
        //            this.loadingCustodianAccountsLadda = false;
        //        });
        //}

        loadLovs(): void {
            this.generalService.getLOVs()
                .then(data => {
                    this.lovs = data
                    this.fundingSources = data.filter(f => f.lovType === domains.LovType.FUNDING_SOURCE);
                    this.custStateGiftGiven = data.filter((value, index, array) => { return value.lovType == domains.LovType.STATES });
                    this.custMannerOfGifts = data.filter(f => f.lovType === domains.LovType.CUST_MANNER_OF_GIFT);
                    this.sourcesOfInitialFunds = data.filter(f => f.lovType === domains.LovType.SOURCE_OF_INITIAL_FUNDS);
                    this.accountPurposes = data.filter(f => f.lovType === domains.LovType.ACCOUNT_PURPOSE);
                    this.pricingTypes = data.filter(f => f.lovType === domains.LovType.PRICING_TYPE);
                    this.brokerageTypes = data.filter(f => f.lovType === domains.LovType.BROKERAGE_TYPE);
                    this.sweepStatuses = data.filter(f => f.lovType === domains.LovType.SWEEP_STATUS && f.extra2 == "Y"); // extra2 - filter for elements to show when creating an account, at creation time, not all elements apply.
                    this.countries = this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
                        .concat(this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode));
                    this.jointTenancyState = data.filter((value, index, array) => { return value.lovType == domains.LovType.STATES });
                    this.updateFrequencies = data.filter(v => { return v.lovType == domains.LovType.UPDATE_FREQUENCY });
                }, err => this.generalService.showError(err));
        }

        onChangeUpdateFrequency() {
            if (this.selUpdateFrequency.value === this.accountApi.paccount.updateFrequency)
                return;

            this.accountApi.setUpdateFrequency(this.accountApi.paccount.id, this.selUpdateFrequency.value)
                .then(rsp => {
                    this.accountApi.paccount.updateFrequency = this.selUpdateFrequency.value;
                    toastr.success("Update frequency has been set");
                }, err => {
                    this.selUpdateFrequency = { value: this.accountApi.paccount.updateFrequency };
                    this.generalService.showError(err);
                });
        }

        onChangeHoldingsMaintainedExSystem(): void {

            //console.log("Holdings Maintained in External System", this.accountApi.paccount.holdingsMaintaindExSystem ? "Yes" : "No");

            // If we have external holdings in the database for this account and the user is asking to
            // maintan the holdings in the external system, prompt the user to confirm that they are 
            // OK if we delete the external holdings from the database.
            // The grid is picked once the account's allocation plan resolves, so it may not be
            // bound yet - no grid means no holdings to warn about.
            const boundHoldings = this.outsideHoldingsController ? this.outsideHoldingsController.holdings : null;
            if (this.accountApi.paccount.holdingsMaintaindExSystem == true && boundHoldings && boundHoldings.length > 0) {
                var msg = "If you select this option, the holdings that you have created in AdvisorOp will be deleted."
                    + "\n\nARE YOU SURE?\n\nPRESS OK TO CONFIRM, CANCEL TO GO BACK.";

                if (window.confirm(msg)) {
                    this.setExternalHoldings().then(response => {
                        this.deleteHoldingsForAccount().then(success => {
                            toastr.success("AdvisorOp holdings for this account have been deleted.");
                            this.flagDeletedHoldings = 1;
                            this.accountApi.paccount.holdingsMaintaindExSystem = true;
                            this.checkManualHoldingsComplete();
                            this.manualSetupDirty = false;
                        });
                    });
                } else {
                    this.accountApi.paccount.holdingsMaintaindExSystem = false;
                    this.checkManualHoldingsComplete();
                    return;
                }
            } else {
                this.setExternalHoldings().then(response => {
                    toastr.success("External holdings indicator has been updated.");
                    this.flagDeletedHoldings = 0;
                    this.checkManualHoldingsComplete();
                    this.manualSetupDirty = false;
                });
            }
        }

        checkIsSelectedProductInactive(accountId: number): void {
            if (this.accountApi.paccount.productId != null && this.accountApi.paccount.productId != 0) {
                this.advisorService.checkIsProductInactive(accountId)
                    .then(response => {
                        if (response.data == false) {
                            toastr.error("The product on this account is now inactive, please select a new product.");
                            //this.step = AW_Step.BASIC_INFORMATION;
                        }
                    })
                    .catch(error => {
                        toastr.error("Unable to validate product.");
                    })
            }
        }

        checkIsSelectedProductProposalInvestmentModels(accountId: number): void {
            this.advisorService.checkIsProductInactiveForProposalInvestments(accountId)
                .then(response => {

                    if (response.data.length != 0) {
                        response.data.map(v => toastr.error("Selected product: " + v.managerProductName + " is not active, please select other one."));
                        //this.step = AW_Step.INVESTMENT_PROPOSAL;
                    }
                })
                .catch(error => {
                    toastr.error("Unable to validate product.");
                })
        }

        calcBindTotalInvestmentAmount(changedByUserOnUI: boolean = false): void {
            this.totalInvestmentAmount = this.fundingComponents.reduce(function (prev, cur) {
                return +prev + +cur.amount;
            }, 0);

            if (this.accountApi.paccount.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS
                || this.accountApi.paccount.accountType == domains.InvestmentType.MANAGED_MODELS
                || this.accountApi.paccount.accountType == domains.InvestmentType.SMA) {
                this.cuProposalController.model.amount = this.totalInvestmentAmount;
                this.cuProposalController.amountChanged(changedByUserOnUI);
                this.accountApi.paccount.investmentAmount = this.totalInvestmentAmount
            } else if (this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT) {
                this.accountApi.paccount.investmentAmount = this.totalInvestmentAmount
                this.accountInvestmentController.investmentAmountChanged(changedByUserOnUI);
            }

            this.checkFundingComponentsComplete();
        }

        loadAccount(accountId: number): ng.IPromise<void> {

            //var this = this;

            return this.accountApi.getById(accountId)
                .then(data => {
                    if ((data.data.status != domains.AccountStatus.SETUP)
                        && (data.data.status != domains.AccountStatus.PROPOSED)
                        && (data.data.status != domains.AccountStatus.OPENING)) {
                        toastr.error("This account can not be updated via the wizard because it must be in the SETUP, PROPOSED or OPENING state.");
                        this.$router.navigate(['AdvisorAccounts', { accountStatus: 1 }]);
                        return;
                    }

                    if (data.data.accountType == domains.InvestmentType.CUSTODIAN_ACCOUNT) {
                        toastr.error("You can not directly update a custodian account. Please select a linked invesment account.");
                        this.$router.navigate(['AdvisorAccounts', { accountStatus: 1 }]);
                        return;
                    }

                    this.accountApi.paccount = data.data;
                    this.accountApi.pcustodianAccount.number = data.data.number;
                    this.sourcesOfInitialFunds.forEach(element => {
                        if (element.extra1 == "UNKN" && !this.accountApi.pcustodianAccount.sourceOfInitialFunds) {
                            this.selSourceOfInitialFunds = element;
                        }
                    });
                    this.selPricingType = this.pricingTypes.filter(f => f.value === 1)[0];
                    this.accountApi.pcustodianAccount.pricingType = 1; // default Asset-Based pricing type
                    //console.log("ACCOUNT WAS LOADED new-new-account-wiz: ", this.accountApi.paccount);

                    // bind the funding components grid
                    angular.copy(this.accountApi.paccount.fundingComponents, this.fundingComponents);

                    //console.log(`Setting Update Frequency to: ${this.accountApi.paccount.updateFrequency}`);
                    this.selUpdateFrequency = { value: this.accountApi.paccount.updateFrequency };

                    // Load all potential custodians associated with this advisory firm
                    this.loadCustodians(this.accountApi.paccount.advisoryFirm.id).then(() => {

                        if (this.accountApi.paccount.isNewCustodianAccount) {
                            this.createNewCustodianAccount = true;

                            if (this.accountApi.paccount.custodianAccountId) {
                                this.accountApi.getById(this.accountApi.paccount.custodianAccountId)
                                    .then(data => {
                                        angular.copy(data.data, this.accountApi.pcustodianAccount)
                                        if (this.accountApi.pcustodianAccount.status == domains.AccountStatus.OPEN) {
                                            this.createNewCustodianAccount = false;
                                            this.accountApi.paccount.isNewCustodianAccount = false;
                                            //console.log("CUSTODIAN ACCOUNT IS OPEN.....");
                                        } else {
                                            //console.log("CUSTODIAN ACCOUNT IS NOT YET OPEN, BINDING CUSTODIAN ACCOUNT TO GUI");

                                            // Set all of the custodian selection data
                                            this.BindCustodianFromAccount();

                                            if (this.accountApi.pcustodianAccount.custStateGiftGiven)
                                                this.selCustStateGiftGiven = this.custStateGiftGiven.filter(v => v.extra1 === this.accountApi.pcustodianAccount.custStateGiftGiven)[0];
                                            if (this.accountApi.pcustodianAccount.custMannerOfGift)
                                                this.selCustMannerOfGift = <domains.ILOV>{ value: this.accountApi.pcustodianAccount.custMannerOfGift };
                                            if (this.accountApi.pcustodianAccount.sourceOfInitialFunds)
                                                this.selSourceOfInitialFunds = <domains.ILOV>{ extra1: this.accountApi.pcustodianAccount.sourceOfInitialFunds };
                                            if (this.accountApi.pcustodianAccount.accountPurpose >= 0)
                                                this.selAccountPurpose = <domains.ILOV>{ value: this.accountApi.pcustodianAccount.accountPurpose };
                                            if (this.accountApi.pcustodianAccount.pricingType >= 0)
                                                this.selPricingType = <domains.ILOV>{ value: this.accountApi.pcustodianAccount.pricingType };
                                            //else
                                            //    this.selPricingType = null;
                                            if (this.accountApi.pcustodianAccount.brokerageType >= 0)
                                                this.selBrokerageType = <domains.ILOV>{ value: this.accountApi.pcustodianAccount.brokerageType };
                                            if (this.accountApi.pcustodianAccount.sweepStatus) {
                                                this.selSweepStatus = this.sweepStatuses.filter(f => f.extra1 === this.accountApi.pcustodianAccount.sweepStatus)[0];
                                                if (this.selSweepStatus && (this.selSweepStatus.value != domains.SweepStatus.NO_SWEEP))
                                                    this.sweepIsOn = true;
                                                else
                                                    this.sweepIsOn = false;
                                            } else {
                                                this.sweepIsOn = false;
                                            }
                                            //console.log("ctrl.custodianAccount.sweepStatus:", ctrl.custodianAccount.sweepStatus);
                                            //console.log("SWEEP IS ON:", this.sweepIsOn);
                                            //console.log("this.selSweepStatus:", this.selSweepStatus);
                                            //console.log("this.selSweepStatus.value:", this.selSweepStatus.value);
                                            //console.log("domains.SweepStatus.NO_SWEEP:", domains.SweepStatus.NO_SWEEP);
                                            if (this.accountApi.pcustodianAccount.usOfficialOfficeCountry)
                                                this.selUsOfficialOfficeCountry = <domains.ILOV>{ extra2: this.accountApi.pcustodianAccount.usOfficialOfficeCountry };
                                            if (this.accountApi.pcustodianAccount.jointTenancyState)
                                                this.selJointTenancyState = this.jointTenancyState.filter(v => v.extra1 === this.accountApi.pcustodianAccount.jointTenancyState)[0];

                                            // If this account has beneficiaries, force re-save of the custodian account because the user may have exited
                                            // this screen earlier after saving beneficiary information, but before saving the custodian account.
                                            /***Account opening simplification effort***/
                                            // if (this.BeneficiariesRequired() && this.accountApi.paccount.setupCreationType != domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT) {
                                            //     //console.log("SETTING IT DIRTY 6666666");
                                            //     this.custodianAccountIsDirty = true;
                                            // } else {
                                            //     this.custodianAccountIsDirty = false;
                                            // }
                                            console.log("SETTING custodianAccountIsDirty NOT DIRTY ND1");
                                            this.custodianAccountIsDirty = false;
                                            //console.log("INSIDE...CREATE NEW CUSTODIAN ACCOUNT IS", this.createNewCustodianAccount);
                                        }
                                    }, error => this.generalService.showError(error)).finally(() => {
                                        this.setUpDateWatches();
                                        this.custodianAccountInitialized = true;
                                    });
                            }
                            else {
                                this.setUpDateWatches();
                                this.custodianAccountInitialized = true;
                            }
                        }
                        else {
                            this.setUpDateWatches();
                            this.custodianAccountInitialized = true;
                        }
                    });

                    console.log(`Loading orion account ${this.accountApi.paccount.number}`);
                    this.orionService.getAccountByNumber(this.accountApi.paccount.number).then(orionAccount => {
                        console.log(`Orion account loaded...`);
                        // this.orionAccountData = orionAccount.data;
                        this.onOrionAccountSelected(orionAccount.data);
                        this.cuAccountController.bindOrionAccount(orionAccount.data);
                    }, error => {
                        console.log("No Orion account found for account number ", this.accountApi.paccount.number);
                    });
                }, error => this.generalService.showError(error));
        }

        // ///////////////////////
        // calculated properties
        isOutsideInvestmentAccount(): boolean {
            return this.cuAccountController && this.cuAccountController.isOutsideInvestmentAccount();
        }

        isRIAAccount(): boolean {
            return this.cuAccountController && this.cuAccountController.selAdvisoryFirm &&
                this.cuAccountController.selAdvisoryFirm.firmType == domains.FirmType.REGISTERED_INVESTMENT_ADVISOR;
        }

        isProposalCompleted(): boolean {
            //return (this.account.proposal && (this.account.proposal.proposalState == 5 || this.account.proposal.isDiscretionDocumentationOnFile || this.account.proposal.proposalState == 1));
            return (this.accountApi.paccount.proposal
                && (this.accountApi.paccount.proposal.proposalState == domains.ProposalState.SIGNED || this.accountApi.paccount.proposal.isDiscretionDocumentationOnFile || this.accountApi.paccount.proposal.proposalState == domains.ProposalState.ACTIVE));
        }

        //isSetupOnly(): boolean {
        //    return (this.accountApi.paccount.proposal && this.accountApi.paccount.proposal.accountSetupOpen);
        //};

        allowBeneficiaryChanges(): boolean {
            if (this.accountApi.pcustodianAccount && this.accountApi.pcustodianAccount.id > 0 && this.accountApi.pcustodianAccount.extApiTransmitted)
                return false;
            else
                return true;
        }

        //steps awailability
        hasRTGStep(): boolean {
            var ret = (((!this.isOutsideInvestmentAccount()) || this.hasRtgHoldings) && !this.isInsuranceProduct());
            return ret;
        }

        isPershingAccount(): boolean {
            return this.selCustodian && (this.selCustodian.custodian.name === 'Pershing')
        }

        isSchwabAccount(): boolean {
            return this.selCustodian && (this.selCustodian.custodian.name === 'Schwab')
        }

        requireCustodialInfo(): boolean {
            return this.accountApi.paccount.titleType == domains.TitleType.CUSTODIAL
        }

        requireJointTrustInfo(): boolean {
            return (this.accountApi.paccount.titleType == domains.TitleType.INDIVIDUAL_TRANSFER_ON_DEATH
                || this.accountApi.paccount.titleType == domains.TitleType.JOINT_TRANSFER_ON_DEATH)
        }

        requireJointInfo(): boolean {
            return (this.accountApi.paccount.titleType == domains.TitleType.JOINT_TENANT
                || this.accountApi.paccount.titleType == domains.TitleType.JOINT_TRANSFER_ON_DEATH)
        }

        // steps availability based on Account model not CuAccount control
        isInsuranceProduct(): boolean {
            return (this.accountApi.paccount.productTypeId === domains.ProductType.LIFE_INSURANCE ||
                this.accountApi.paccount.productTypeId === domains.ProductType.OTHER_INSURANCE);
        }

        isRTGCompleted(): boolean {
            if (this.accountApi.paccount && this.accountApi.paccount.advisoryFirm) {
                // for RIA firms
                if (this.accountApi.paccount.advisoryFirm.firmType <= 0) {
                    if (this.accountApi.paccount.rtgs == null || this.accountApi.paccount.rtgs.length == 0) {
                        return false;
                    }
                    for (var i = 0; i < this.accountApi.paccount.rtgs.length; i++)
                        if (this.accountApi.paccount.rtgs[i].accountGroupId == null || this.accountApi.paccount.rtgs[i].accountGroupId == 0)
                            return false;
                }
                // for Broker Dealer firms
                else if (this.accountApi.paccount.advisoryFirm.firmType > 0 && (!this.rtq || this.rtq.id <= 0))
                    return false;
                return true;
            } else {
                return false;
            }
        }

        enableOpenAccountStep(): boolean {
            // account and proposal must exist ... unless we are just 'setting up' an already open account,
            // in that case we can also enable the open account step.
            if (this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT || this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                return true;
            else return (this.accountApi.paccount && this.accountApi.paccount.proposal &&
                (this.accountApi.paccount.isDiscretionDocumentationOnFile
                    || this.accountApi.paccount.proposal.proposalState === domains.ProposalState.SIGNED
                    || this.accountApi.paccount.proposal.proposalState === domains.ProposalState.ACTIVE
                    || (this.accountApi.paccount.tampType && (this.accountApi.paccount.tampType != domains.TampType.INTERNAL_TAMP))));
                //|| this.accountApi.paccount.proposal.accountSetupOpen));
        }

        skippingOptionChecked(isDiscretionDocumentationOnFile: boolean): void {
            this.selectedSkippOption = isDiscretionDocumentationOnFile;
        }

        // Currently this is specific to Pershing, we will make this more generic as additional custodians are added to the system.
        // This function takes an optional argument that will reserve an account number before creating/updating the account.
        crtUpdCustodianAcctFromAcct(reserveAcctNumber?: boolean): ng.IPromise<boolean> {

            // Account number is required only for Pershing
            if (this.createNewCustodianAccount && this.isPershingAccount() && this.accountApi.pcustodianAccount.number == "") {
                toastr.error("Account Number is Required when custodian is Pershing.");
                return;
            }

            if (reserveAcctNumber == undefined || reserveAcctNumber == false)
                this.savingCustodianAccountLadda = true;
            else
                this.reservingCustodianAccountLadda = true;

            let formValid1 = true;

            //var itemslist: string[] = new Array("selOfficeRange", "accountNumber");

            if ((this.selCustodian.custodian.hasOfficeRanges) && (!this.selOfficeRange)) {
                formValid1 = false;
                toastr.error("Custodian office range / master account is Required.");
            }

            this.accountApi.pcustodianAccount.updateFrequency = null;
            if (this.selUpdateFrequency) {
                this.accountApi.pcustodianAccount.updateFrequency = this.selUpdateFrequency.value;
            }
                

            // Form must be complete in order to invoke this step.
            //if (formValid) {
            if (formValid1) {
                this.accountApi.pcustodianAccount.cloneAccountId = this.accountApi.paccount.id;

                if (this.selCustodian)
                    this.accountApi.pcustodianAccount.custodianId = this.selCustodian.custodianId;
                else
                    this.accountApi.pcustodianAccount.custodianId = null;

                if (this.selOfficeRange)
                    this.accountApi.pcustodianAccount.officeRangeId = this.selOfficeRange.id;
                else
                    this.accountApi.pcustodianAccount.officeRangeId = null;

                if (this.selCustStateGiftGiven)
                    this.accountApi.pcustodianAccount.custStateGiftGiven = this.selCustStateGiftGiven.extra1;
                else
                    this.accountApi.pcustodianAccount.custStateGiftGiven = null;

                if (this.selCustMannerOfGift)
                    this.accountApi.pcustodianAccount.custMannerOfGift = this.selCustMannerOfGift.value;
                else
                    this.accountApi.pcustodianAccount.custMannerOfGift = null;

                if (this.selRepfeeGroup)
                    this.accountApi.pcustodianAccount.repFeeGroupId = this.selRepfeeGroup.id;
                else
                    this.accountApi.pcustodianAccount.repFeeGroupId = null;

                if (this.selSourceOfInitialFunds)
                    this.accountApi.pcustodianAccount.sourceOfInitialFunds = this.selSourceOfInitialFunds.extra1;
                else
                    this.accountApi.pcustodianAccount.sourceOfInitialFunds = null;

                if (this.selAccountPurpose)
                    this.accountApi.pcustodianAccount.accountPurpose = this.selAccountPurpose.value;
                else
                    this.accountApi.pcustodianAccount.accountPurpose = null;

                if (this.selPricingType)
                    this.accountApi.pcustodianAccount.pricingType = this.selPricingType.value;
                else
                    this.accountApi.pcustodianAccount.pricingType = null;

                if (this.selBrokerageType)
                    this.accountApi.pcustodianAccount.brokerageType = this.selBrokerageType.value;
                else
                    this.accountApi.pcustodianAccount.brokerageType = null;

                if (this.selSweepStatus)
                    this.accountApi.pcustodianAccount.sweepStatus = this.selSweepStatus.extra1;
                else
                    this.accountApi.pcustodianAccount.sweepStatus = null;

                if (this.selJointTenancyState)
                    this.accountApi.pcustodianAccount.jointTenancyState = this.selJointTenancyState.extra1;
                else
                    this.accountApi.pcustodianAccount.jointTenancyState = null;

                // force central bank account ind to false if foreign bank account is false
                if (this.accountApi.pcustodianAccount.foreignBankAccount == false)
                    this.accountApi.pcustodianAccount.centralBankAcctInd = null;

                if (this.accountApi.pcustodianAccount.nonUSOfficial == false) {
                    this.accountApi.pcustodianAccount.usOfficialFirstName = null;
                    this.accountApi.pcustodianAccount.usOfficialLastName = null;
                    this.accountApi.pcustodianAccount.usOfficialOfficeHeld = null;
                    this.accountApi.pcustodianAccount.usOfficialOfficeCountry = null;
                }
                else {
                    if (this.selUsOfficialOfficeCountry)
                        this.accountApi.pcustodianAccount.usOfficialOfficeCountry = this.selUsOfficialOfficeCountry.extra2;
                    else
                        this.accountApi.pcustodianAccount.usOfficialOfficeCountry = null;
                }

                if (this.selSourceOfInitialFunds && (this.selSourceOfInitialFunds.extra1 != "OTHR"))
                    this.accountApi.pcustodianAccount.initialFundsOtherText = null;

                if (this.selAccountPurpose && (this.selAccountPurpose.name != "Other"))
                    this.accountApi.pcustodianAccount.accountPurposeOtherText = null;

                // Custodian account will take the same name as its child account
                this.accountApi.pcustodianAccount.name = this.accountApi.paccount.name;

                // Is this account owning creation of the custodian account?
                // If yes, set the attribute on the account
                if (this.createNewCustodianAccount) {
                    this.accountApi.paccount.isNewCustodianAccount = true;

                    //console.log("Saving custodian account:", this.custodianAccount);

                    // NOTE: Beneficiaries will be copied from the account to the custodian account on the server...

                    if (reserveAcctNumber == undefined || reserveAcctNumber == false) {
                        //console.log("GOING TO CREATE NEW CA:......####", this.accountApi.pcustodianAccount);

                        return this.advisorService.crtUpdCustodianAcctFromAcct(this.accountApi.pcustodianAccount)
                            .then((data) => {
                                toastr.success("Custodian account data has been saved.");
                                this.custodianAccountWatchesOn = false;
                                this.accountApi.pcustodianAccount = <domains.IAccount>data.data;
                                setTimeout(() => { this.custodianAccountWatchesOn = true }, 3000);
                                //console.log("CACREATED:", this.accountApi.pcustodianAccount);
                                this.accountApi.paccount.custodianAccountId = this.accountApi.pcustodianAccount.id;
                                console.log("SETTING custodianAccountIsDirty NOT DIRTY ND2");
                                this.custodianAccountIsDirty = false;
                                this.savingCustodianAccountLadda = false;
                                return true;
                            }, err => this.generalService.showError(err)).finally(() => {
                                this.savingCustodianAccountLadda = false;
                            });
                    } else {
                        // Normally this attribute would be copied on the server side from the account to the custodian account,
                        // But we will set it here because it is needed to reserve the account number at the custodian,
                        // and this will save us from having to first load the account on the server to get the firm ID. We already know it here.
                        this.accountApi.pcustodianAccount.advisoryFirmId = this.accountApi.paccount.advisoryFirmId;

                        return this.advisorService.crtUpdCustodianAcctFromAcctWithReserve(this.accountApi.pcustodianAccount)
                            .then((data) => {
                                toastr.success("Custodian account data has been saved and account number has been reserved at custodian.");
                                this.custodianAccountWatchesOn = false;
                                this.accountApi.pcustodianAccount = <domains.IAccount>data.data;
                                setTimeout(() => { this.custodianAccountWatchesOn = true }, 3000);
                                this.accountApi.paccount.custodianAccountId = this.accountApi.pcustodianAccount.id;
                                console.log("SETTING custodianAccountIsDirty NOT DIRTY ND3");
                                this.custodianAccountIsDirty = false;
                                this.reservingCustodianAccountLadda = false;
                                return true;
                            }, err => this.generalService.showError(err)).finally(() => {
                                this.reservingCustodianAccountLadda = false;
                            });
                    }
                } else {
                    if (reserveAcctNumber == undefined || reserveAcctNumber == false)
                        this.savingCustodianAccountLadda = false;
                    else
                        this.reservingCustodianAccountLadda = false;
                }
            } else {
                if (reserveAcctNumber == undefined || reserveAcctNumber == false)
                    this.savingCustodianAccountLadda = false;
                else
                    this.reservingCustodianAccountLadda = false;
            }
        }

        startCustodianDocuments() {
            if (this.showDocumentSelection == true) {
                this.showDocumentSelection = false;
                return;
            } else {
                this.loadingDoclistLadda = true;
                // Form must be complete in order to invoke this step.
                //this.advisorService.getCustodianDocuments(this.account.custodianId)
                this.advisorService.getCustodianDocuments(this.accountApi.pcustodianAccount.custodianId)
                    .then((data) => {
                        this.custodianDocuments = data.data;
                        this.showDocumentSelection = true;
                        //console.log("$ CustodianDocuments", this.custodianDocuments);
                    }).finally(() => {
                        this.loadingDoclistLadda = false;
                    });
            }
        }

        endCustodianDocuments() {
            this.showDocumentSelection = false;
            return;
        }

        uploadAcctDetailsToCustodian() {
            this.uploadingToCustodianLadda = true;
            this.transmitting = true;
            // for this we must validate the full form
            if (this.validateOpenAccountForm()) {
                return this.advisorService.uploadDataToCustodian(this.accountApi.pcustodianAccount)
                    .then((data) => {
                        toastr.success("You have successfully uploaded the custodian account data to the custodian.");
                        this.custodianAccountWatchesOn = false
                        this.accountApi.pcustodianAccount = <domains.IAccount>data.data;
                        setTimeout(() => { this.custodianAccountWatchesOn = true }, 3000);
                        return true;
                    }, err => this.generalService.showError(err)).finally(() => {
                        this.transmitting = false;
                        this.uploadingToCustodianLadda = false;
                    });
            } else {
                this.transmitting = false;
                this.uploadingToCustodianLadda = false;
            }
        }

        //CustodianDocumentChanged() {
        //  if (this.selCustodianDocument.platform === domains.ReportingPlatform.LASERAPP) {
        //      this.showGenerateDocButton = true;
        //  } else {
        //      this.showGenerateDocButton = false;
        //  }
        //}

        CustodianDocumentsChanged(selectedItems: domains.ICustodianDocument[]) {
            this.selCustodianDocuments = selectedItems;
            this.laserAppGenRequest = [];
            for (var doc of this.selCustodianDocuments) {
                if (doc.platform === domains.ReportingPlatform.LASERAPP) {
                    var laReq: domains.ILaserAppGenRequest = {
                        formGuid: doc.uid,
                        documentType: doc.documentType
                    };
                    this.laserAppGenRequest.push(laReq);
                }
            }
            if (this.laserAppGenRequest.length > 0) {
                this.generateDocLabel = "Generate " + this.laserAppGenRequest.length.toString();
                if (this.laserAppGenRequest.length == 1)
                    this.generateDocLabel = this.generateDocLabel + " Document";
                else
                    this.generateDocLabel = this.generateDocLabel + " Documents";

                this.showGenerateDocButton = true;
            } else {
                this.generateDocLabel = "";
                this.showGenerateDocButton = false;
            }
            //console.log("In new-new-account-wiz callback -- FORMGUIDS ARE:",this.formGuids);
            //console.log("In new-new-account-wiz callback -- FORMGUIDS ARE:", this.laserAppGenRequest);
        }

        generateCustodianDocument() {
            if (this.laserAppGenRequest.length > 0) {
                this.genCustodianDocLadda = true
                this.advisorService.generateLaserAppForms(this.accountApi.pcustodianAccount.id, this.laserAppGenRequest)
                    .then(response => {
                        //console.log("Response from LaserApp test:", response);
                        this.laserAppWnd = window.open(response.data, "_blank");
                    }, err => this.generalService.showError(err)).finally(() => {
                        this.genCustodianDocLadda = false;
                    });
            }
        }

        //stateCreateRepFee: boolean = false;
        //isInEditState: number;
        //onChangeNewRepGroup(): void {
        //    if (this.stateCreateRepFee) {
        //        this.isInEditState = 1;
        //    } else {
        //        this.isInEditState = 0;
        //    }
        //}

        //onGroupCreated(event: domains.IRepFeeGroup): void {
        //    this.stateCreateRepFee = false;
        //    this.selRepfeeGroup = event;
        //}

        //checkRightsForCreateNewRepGroup(): boolean {
        //    if (this.user.role == 'ADVISORY_ADMIN' || this.user.role == 'ADVISORY_LEAD' || this.user.role == 'SERVICER')
        //        return true;
        //    return false;
        //}

        BeneficiariesRequired(): boolean {
            return this.cuAccountController
                && this.cuAccountController.selSetupCode && this.cuAccountController.selSetupCode != this.setupCode_AddExisting // bene not required when we are adding to an existing custodian account...
                && this.cuAccountController.selAccountType && this.cuAccountController.selAccountType.value != domains.InvestmentType.OUTSIDE_INVESTMENT
                && this.cuAccountController.selTitleType &&
                (this.cuAccountController.selTitleType.value == domains.TitleType._529_PLAN_ACCOUNT
                    || this.cuAccountController.selTitleType.value == domains.TitleType.IRA
                    || this.cuAccountController.selTitleType.value == domains.TitleType.INDIVIDUAL_TRANSFER_ON_DEATH
                    || this.cuAccountController.selTitleType.value == domains.TitleType.JOINT_TRANSFER_ON_DEATH);
        }

        //paintWhenInitialized(): void {
        //    if (this.accountApi && this.accountApi.paccount && this.accountApi.paccount.id > 0) {
        //        //console.log("cuAccountReady", this.cuAccountReady);
        //        //console.log("this.accountApi.paccount.accountType", this.accountApi.paccount.accountType);
        //        //console.log("this.cuAccountInvestmentReady", this.cuAccountInvestmentReady);
        //        //console.log("this.cuProposalReady", this.cuProposalReady);
        //        //console.log("this.accountInitialized", this.accountInitialized);
        //        if (this.cuAccountControllerReady
        //            && (((this.accountApi.paccount.accountType === domains.InvestmentType.DIRECT_INVESTMENT || this.accountApi.paccount.accountType === domains.InvestmentType.OUTSIDE_INVESTMENT) && this.cuAccountInvestmentControllerReady && this.cuOutsideHoldingsControllerReady)
        //                || ((this.accountApi.paccount.accountType === domains.InvestmentType.INDIVIDUAL_HOLDINGS || this.accountApi.paccount.accountType === domains.InvestmentType.MANAGED_MODELS) && this.cuProposalControllerReady)
        //                || (this.accountApi.paccount.id > 0 && !this.accountApi.paccount.accountType))
        //            && this.accountInitialized) {
        //            this.calcBindTotalInvestmentAmount(false)
        //            this.invamountIsDirty = false;
        //            if (this.accountApi.paccount.accountType === domains.InvestmentType.DIRECT_INVESTMENT || this.accountApi.paccount.accountType === domains.InvestmentType.OUTSIDE_INVESTMENT) {
        //                this.checkManualHoldingsComplete();
        //            }
        //            this.collapseCompleted();
        //            console.log("INITIALIZED FOR PAINTING------+___+_+_+______++_", this.accountApi.paccount.name);
        //            this.isInitializing = false;
        //            console.log("THIS IS: ", this);
        //            console.log("THIS INITIALIZING: ", this.isInitializing);
        //        } else {
        //            let that = this;
        //            console.log("NOT INITIALIZED FOR PAINTING YET------+___+_+_+______++_", that.accountApi.paccount.name);
        //            console.log("THAT IS: ", that);
        //            console.log("THAT INITIALIZING: ", that.isInitializing);
        //            setTimeout(function () {that.paintWhenInitialized() }, 1000);
        //        }
        //    }
        //}

        paintWhenInitialized(): void {
            // Here we will watch for all controllers to be fully initialized before we paint the screen
            let that = this;
            that.initTimer = setInterval(() => {
                //console.log("IN SETINITIALIZED...+++++++-------+++++++-------");
                if (that.accountApi && that.accountApi.paccount) {
                    //console.log("cuAccountReady", this.cuAccountReady);
                    //console.log("this.accountApi.paccount.accountType", this.accountApi.paccount.accountType);
                    //console.log("this.cuAccountInvestmentReady", this.cuAccountInvestmentReady);
                    //console.log("this.cuProposalReady", this.cuProposalReady);
                    //console.log("this.accountInitialized", this.accountInitialized);
                    if (that.cuAccountControllerReady
                        && (((that.accountApi.paccount.accountType === domains.InvestmentType.DIRECT_INVESTMENT || that.accountApi.paccount.accountType === domains.InvestmentType.OUTSIDE_INVESTMENT) && that.cuAccountInvestmentControllerReady && that.cuOutsideHoldingsControllerReady)
                        || ((that.accountApi.paccount.accountType === domains.InvestmentType.INDIVIDUAL_HOLDINGS || that.accountApi.paccount.accountType === domains.InvestmentType.MANAGED_MODELS || that.accountApi.paccount.accountType === domains.InvestmentType.SMA) && that.cuProposalControllerReady)
                        || (that.accountApi.paccount.id > 0 && !that.accountApi.paccount.accountType))
                        && that.accountInitialized && that.custodianAccountInitialized) {
                        //console.log("HEREHEREHERE------+___+_+_+______++_", this.accountApi.paccount.name);
                        clearInterval(that.initTimer);
                        that.calcBindTotalInvestmentAmount(false)
                        that.invamountIsDirty = false;
                        if (that.accountApi.paccount.accountType === domains.InvestmentType.DIRECT_INVESTMENT || that.accountApi.paccount.accountType === domains.InvestmentType.OUTSIDE_INVESTMENT) {
                            that.checkManualHoldingsComplete();
                        }
                        that.collapseCompleted();
                        //console.log("INITIALIZED FOR PAINTING------+___+_+_+______++_", this.accountApi.paccount.name);
                        var __this = that;
                        that.$scope.$apply(function () {
                            __this.isInitializing = false;
                        });
                        //that.isInitializing = false;
                    }
                }
            }, 250);
        }

        // overrides ...
        $onInit(): void {
            this.accountApi.paccount = { id: 0, name: "", number: "", company: "", productDescription: "", directManagerDesc: "", notes: "", manualAccount: {}, investors: [], rtgs: [], holdingsMaintaindExSystem: true };
            this.accountApi.pcustodianAccount = { id: 0, name: "", number: "", company: "", productDescription: "", directManagerDesc: "", notes: "", manualAccount: {}, investors: [], rtgs: [], holdingsMaintaindExSystem: true, isNumberReserved: false, isDiscretionDocumentationOnFile: false, sweepFundsPercent: 0 };

            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.impersonatedByServicer = (this.user.impersonatedByRole == "SERVICER" || this.user.impersonatedByRole == "SERVICER_LEAD" || this.user.impersonatedByRole == "SERVICER_ADMIN")
                //console.log("USER", this.user);
            });
            this.loadLovs();
            //this.loadRepfeeGroups();
        };

        $routerOnActivate(next, previous) {
            //console.log("IN ROUTERONACTIVATE ....23.23.23.2.32.3.23.23.23.2..23.23.23.23....");
            if (next.params.accountId) {
                //this.isInitializing = true;

                //console.log("LOADING EXISTING ACCOUNT...");
                this.accountApi.accountWizEditing = true;

                let that = this;

                this.loadAccount(<number>next.params.accountId)
                    .then(data => {
                        that.accountInitialized = true;
                    }, err => {
                        toastr.error("You are not allowed to perform this action.");
                        this.$router.navigate(['AdvisorAccounts', { accountStatus: 1 }]);
                    });

                this.paintWhenInitialized();

            } else {
                //console.log("AAAA");
                this.accountApi.accountWizEditing = false;
                // Initialize the account that is shared between the various controllers used by this wizard
                //console.log("BBBB");
                this.collapseCompleted();
                //var __this = this;
                //console.log("CCCC");
                this.accountInitialized = true;
                this.setUpDateWatches();
                this.custodianAccountInitialized = true;
                //console.log("DDDD");
                this.isInitializing = false;
            }
        }
    }

    class NewNewAccountWiz implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        $canActivate;

        //static $inject = ["advisorService"];
        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = NewNewAccountWizController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/new-new-account-wiz.html';
            this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
                if (advisorService.isAdminModeEnabled()) {
                    toastr.info("Please exit from Admin Mode to enable account wizard");
                    return false;
                }
                return true;
            }];
        }
    }
    angular.module(Constants.APP).component("newNewAccountWiz", new NewNewAccountWiz());
}